// extracted by mini-css-extract-plugin
export default {"settings":"p26gQdLYD26fTYcP780N","container":"TPdPKRxwTt_FBP8NLB9g"};